import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';
import Swal from "sweetalert2";
import axios from "axios";
import { hasPrivilege } from '../utils/hasPrivilege';
import { FiChevronDown, FiRefreshCw } from 'react-icons/fi';

const PlayerBatch = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const { selectedCenter, setSelectedCenter } = useUser();
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { userData } = useUser();
  const token = localStorage.getItem('auth-token');


  const fetchPlayersData = async () => {
    setLoading(true)
    setError('')
    if (selectedCenter) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_ACADEMY_PLAYERS}/${selectedCenter}/player-batches`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          }
        );

        const result = await response.json();

        if (result.success) {
          const playerBatches = result?.data?.playerBatches || [];
          const updatedPlayers = playerBatches.map((batch) => {
            const playerId = batch?.player_id;

            return {
              id: playerId,
              name: batch?.player_name || '-',
              parentName: batch?.parent_name || '-',
              status: batch?.status || 'Inactive',
              category: batch?.player_category || '-',
              level: batch?.player_level || '-',
              mobileNumber: batch?.mobile_number || '-',
              parentNumber: batch?.parent_mobile_number || '-',
              batchId: batch?.batch_id || '-',
              batch: batch?.batch_name || '-',
              primary: batch?.primary ? 'Yes' : 'No',
              dob: batch?.dob || '-',
            };
          });

          setPlayers(updatedPlayers);
        }
      } catch (error) {

        setError('Error fetching data: ' + error.message);
      }
      finally {
        setLoading(false);
      }
    };


  }
  useEffect(() => {
    fetchPlayersData();
  }, [selectedCenter]);



  const headers = [
    { label: "Name", key: "name" },
    { label: "Parent Name", key: "parentName" },
    { label: "Category", key: "category" },
    { label: "Level", key: "level" },
    { label: "Mobile Number", key: "mobileNumber" },
    { label: "Parent Number", key: "parentNumber" },
    { label: "Date of Birth", key: "dob" },
    { label: "Batch", key: "batch" },
    { label: "Primary", key: "primary" },
    { label: "Status", key: "status" },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [action, setAction] = useState('');
  const [formData, setFormData] = useState({
    name: '',
    parentName: '',
    category: '',
    level: '',
    mobileNumber: '',
    parentNumber: '',
    dob: '',
    batch: '',
    primary: '',
    status: '',
  });

  const navigate = useNavigate();
  const [dropdownOpen, setDropdownOpen] = useState(null);

  const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });

  const toggleDropdown = (playerId, batchId, e) => {
    e.stopPropagation();
    const key = `${playerId}-${batchId}`;
    if (dropdownOpen === key) {
      return setDropdownOpen(null);
    }
    const { bottom, left } = e.currentTarget.getBoundingClientRect();
    setDropdownPos({
      top: bottom + window.scrollY,
      left: left + window.scrollX,
    });
    setDropdownOpen(key);
  };
  useEffect(() => {
    const closeOnScroll = () => setDropdownOpen(null);

    window.addEventListener('scroll', closeOnScroll, true);
    return () => window.removeEventListener('scroll', closeOnScroll, true);
  }, []);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const handleNewPlayer = () => {
    navigate('/createNewPlayer');
  };


  const handleDeletePlayer = (playerId, batchId) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!"
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(process.env.REACT_APP_API_REMOVE_PLAYER, {
            params: { batch_id: batchId, player_id: playerId },
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`,
            },
          })
          .then((response) => {
            Swal.fire({
              icon: "success",
              title: "Deleted!",
              text: "The player has been removed.",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });

            setPlayers((prevPlayers) => prevPlayers.filter((player) => player.id !== playerId));
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Error!",
              text: "Something went wrong.",
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
            });
          });
      }
    });
  };
  const confirmDelete = () => {
    const updatedPlayers = players.filter((player) => player.id !== selectedPlayer.id);
    setPlayers(updatedPlayers);
    setIsModalOpen(false);
  };

  const handleSaveEdit = () => {
    const updatedPlayers = players.map((player) =>
      player.id === selectedPlayer.id ? { ...player, ...formData } : player
    );
    setPlayers(updatedPlayers);
    setIsModalOpen(false);
  };

  const handleNavigate = (event, url) => {
    if (event.metaKey || event.ctrlKey) {
      window.open(url, "_blank");
    } else {
      navigate(url);
    }
  };

  const handlePlayerAttendance = (event, playerId, batchId) => {
    handleNavigate(event, `/playerAttendance?playerId=${playerId}&batchId=${batchId}`);
  };

  const handlePerformance = (event, playerId, batchId) => {
    handleNavigate(event, `/performance?playerId=${playerId}&batchId=${batchId}`);
  };

  const handlePlayerPayment = (event, playerId, batchId) => {
    handleNavigate(event, `/playerpaymentDetail?playerId=${playerId}&batchId=${batchId}`);
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const filteredPlayers = players.filter((player) =>
    Object.values(player)
      .join(' ')
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );

  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const [sortConfig, setSortConfig] = useState({
    key: "name",
    direction: "ascending",
  });
  const handleSort = (columnKey) => {
    let direction = "ascending";
    if (sortConfig.key === columnKey && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key: columnKey, direction });
  };

  const sortData = (data) => {
    const { key, direction } = sortConfig;

    return [...data].sort((a, b) => {
      let valueA = a[key] ?? "";
      let valueB = b[key] ?? "";

      if (typeof valueA === "string" && typeof valueB === "string") {
        valueA = valueA.toLowerCase();
        valueB = valueB.toLowerCase();
      }

      if (typeof valueA === "boolean" && typeof valueB === "boolean") {
        return direction === "ascending" ? valueA - valueB : valueB - valueA;
      }

      if (typeof valueA === "number" && typeof valueB === "number") {
        return direction === "ascending" ? valueA - valueB : valueB - valueA;
      }

      return direction === "ascending" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    });
  };
  const sortedData = sortData(filteredPlayers);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdown = document.querySelector('.custom-dropdown-player');
      if (dropdown && !dropdown.contains(event.target) && !event.target.closest('.dots-btn-player')) {
        setDropdownOpen(null);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };
  const totalEntries = filteredPlayers.length;
  const indexOfFirstEntry = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
  const indexOfLastEntry = totalEntries > 0 ? Math.min(currentPage * rowsPerPage, totalEntries) : 0;

  return (
    <div className="enrollment-container">
      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>
        {hasPrivilege(userData, 'COACHING', 'PLAYER_BATCHES_MODIFY') && (
          <button
            className="create-button-new"
            onClick={handleNewPlayer}
          >
            <span className="create-button__icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="23"
                height="23"
                className="create-button__svg"
              >
                <path
                  d="M12 5v14M5 12h14"
                  stroke="white"
                  strokeWidth="2.3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span className="create-button__label">
              Create Player
            </span>
          </button>
        )}
      </div>
      <div className="items-and-dues">
        <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
          <option value={10}>10 items per page</option>
          <option value={50}>50 items per page</option>
          <option value={75}>75 items per page</option>
          <option value={100}>100 items per page</option>
        </select>
        <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
        <button className="tt-action-btn" onClick={fetchPlayersData}>
          <FiRefreshCw className={`refresh-icon ${loading ? 'spin' : ''}`} />
          Refresh
        </button>
      </div>

      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredPlayers.length === 0 && (
        <div className="error-message">No data available</div>
      )}
      <div className="payment-list-scroll-container" style={{ overflowY: 'auto' }}>
        <table className="payment-list-table">
          <thead>
            <tr>
              {headers.map(({ key, label }) => (
                <th key={key} className="challenges-column" onClick={() => handleSort(key)}>
                  <div className="th-content">
                    <span>{label}</span>
                    <FiChevronDown
                      className={`sort-icon ${sortConfig.key === key ? 'active' : ''
                        } ${sortConfig.key === key && sortConfig.direction === 'descending' ? 'desc' : ''}`}
                    />
                  </div>
                </th>
              ))}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentRows.map((player) => (
              <tr key={`${player.id}-${player.batchId}`}>
                <td>{player.name}</td>
                <td>{player.parentName}</td>
                <td>{player.category}</td>
                <td>{player.level}</td>
                <td>{player.mobileNumber}</td>
                <td>{player.parentNumber}</td>
                <td>{player.dob}</td>
                <td>{player.batch}</td>
                <td>{player.primary}</td>
                <td>{player.status}</td>

                <td className="sport-actions-column">
                  <button
                    className="dots-btn-player"
                    type="button"
                    onClick={(e) => toggleDropdown(player.id, player.batchId, e)}
                    style={{
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      fontSize: '24px',
                    }}
                  >
                    &#x22EE;
                  </button>

                  {dropdownOpen === `${player.id}-${player.batchId}` && (
                    <div
                      className="custom-dropdown-player"
                      style={{
                        position: 'absolute',
                        top: dropdownPos.top,
                        left: dropdownPos.left,
                        zIndex: 9999,
                        backgroundColor: 'white',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                        minWidth: '180px',
                      }}
                    >
                      {(hasPrivilege(userData, 'COACHING', 'PLAYER_BATCHES_VIEW') ||
                        hasPrivilege(userData, 'COACHING', 'PLAYER_BATCHES_MODIFY')) && (
                          <>
                            <button
                              className="dropdown-item"
                              onClick={(event) => handlePlayerAttendance(event, player.id, player.batchId)}
                            >
                              Attendance
                            </button>

                            <button
                              className="dropdown-item"
                              onClick={(event) => handlePerformance(event, player.id, player.batchId)}
                            >
                              Performance
                            </button>
                          </>
                        )}

                      {hasPrivilege(userData, 'COACHING', 'PLAYER_BATCHES_MODIFY') && (
                        <>
                          <button
                            className="dropdown-item"
                            onClick={(event) => handlePlayerPayment(event, player.id, player.batchId)}
                          >
                            Update Player Payment
                          </button>
                          <button
                            className="dropdown-item"
                            onClick={() => handleDeletePlayer(player.id, player.batchId)}
                          >
                            Remove
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default PlayerBatch;
